module.exports = __webpack_public_path__ + "img/Figma-logo.bfc8530d.svg";